import * as React from 'react';
import { FC, ReactNode } from 'react';
import locales from 'app/CasinoGames/locales';
import { GameStarter } from './useGameStarter';
import { Game, CasinoGamesProps } from './types';

const Button: FC<{ className: string; attrs: { onClick?: () => void; href?: string }; children: ReactNode }> = ({
  className,
  attrs,
  children,
}) => (
  <div className="rs-column-large-8 rs-center-large">
    <a className={`rs-button rs-button_small rs-button_expanded ${className}`} {...attrs}>
      {children}
    </a>
  </div>
);

type LinksProps = {
  gameStarter: GameStarter;
  game: Game;
  common: CasinoGamesProps['common'];
  linksClassName: string;
};

const Links: FC<LinksProps> = ({ gameStarter, game, common, linksClassName }) => {
  const l = locales();

  return (
    <div className={`overlay ${linksClassName}`}>
      <div className="overlay-border" />
      <Button
        className="realplay mode_real"
        attrs={common.playerPresent ? { onClick: () => gameStarter.openRealGame(game) } : { href: '/login' }}
      >
        {l['i18n-real']}
      </Button>
      {game.demo ? (
        <Button className="practice mode_free" attrs={{ onClick: () => gameStarter.openPracticeGame(game) }}>
          {l['i18n-free']}
        </Button>
      ) : null}
    </div>
  );
};

export default Links;
